export default __webpack_public_path__ + "static/media/step2etdone.0041c145.png";